export default "__VITE_ASSET__CuyRch9I__"